// extracted by mini-css-extract-plugin
module.exports = {"Page":"AnalyticsOverview_Page__16TPC","SlideCard":"AnalyticsOverview_SlideCard__2jvSr","SlideCard2":"AnalyticsOverview_SlideCard2__1PSoA"};